import { useSearchItems } from 'services/search/useSearchItems';

export const useSupportingItems = (campaignId: number) =>
  useSearchItems({ supportedCampaignId: campaignId, size: 12, sortType: 'RECENT' });
